import React, { useState, useEffect, useCallback } from "react";
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Preloader from '../Preloader';


const ClientSlider = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`partners`;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPagedata = async () => {
        setLoading(true);
        try {
            const [partnerRes] = await Promise.all([
            axios.get(apiUrl),
             ]);
            setData(partnerRes.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        };
        setLoading(false);
    }
    fetchPagedata();
  }, []);  

  return (
        <div className="client-carousel">
            <div className="container">
                <h5 className="client-carousel__title">Trusted Partners</h5>
                { loading && <Preloader />}
                <Swiper
                    className="client-carousel__one growim-owl__carousel"
                    modules={[ Pagination, Autoplay]}
                    slidesPerView={3}
                    pagination={false}
                    autoplay={{ delay: 3000}}
                    loop={true}
                    breakpoints={{
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 6,
                            spaceBetween: 65,
                        },
                    }}
                    onSwiper={(swiper) => console.log(swiper)}
                >
                    { data.map(( item, index) => {
                        return(
                        <SwiperSlide key={index}>
                            <div className="client-carousel__one__item">
                                <img src={ item?.image } alt={ item?.name } />
                            </div>
                        </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
        </div>
  )
}

export default ClientSlider